// src/components/Breadcrumb.jsx
import { ChevronRightIcon, ArrowLeftIcon } from '@heroicons/react/24/outline';

const Breadcrumb = ({ items, onBack, backLabel = 'BACK' }) => {
    if (!items || items.length === 0) return null;

    return (
        <div className="flex items-center gap-3 bg-gray-800 border border-gray-700 px-4 py-2">
            {onBack && (
                <button
                    onClick={onBack}
                    className="flex items-center gap-1.5 px-2 py-1 bg-violet-600 text-white font-mono text-xs font-bold hover:bg-violet-500 transition-colors"
                >
                    <ArrowLeftIcon className="h-3 w-3" />
                    {backLabel}
                </button>
            )}
            <nav className="flex items-center gap-2 font-mono text-xs">
                {items.map((item, index) => (
                    <span key={index} className="flex items-center gap-2">
                        {index > 0 && (
                            <ChevronRightIcon className="h-3 w-3 text-gray-600" />
                        )}
                        {item.onClick ? (
                            <button
                                onClick={item.onClick}
                                className="text-gray-400 hover:text-white transition-colors"
                            >
                                {item.label}
                            </button>
                        ) : (
                            <span className={index === items.length - 1 ? 'text-white' : 'text-gray-400'}>
                                {item.label}
                            </span>
                        )}
                    </span>
                ))}
            </nav>
        </div>
    );
};

export default Breadcrumb;
